import { Typography } from '../ui';

const LabelValueColumn = ({
  label,
  value,
  valueVariant = 'body-1',
  valueWeight = 'medium'
}: {
  label: string;
  value: React.ReactNode | string;
  valueVariant?: any;
  valueWeight?: any;
}) => {
  if (!value) return null;

  const renderValue = () => {
    if (typeof value === 'string') {
      return (
        <Typography variant={valueVariant} weight={valueWeight}>
          {value}
        </Typography>
      );
    }

    return value;
  };

  return (
    <div className="flex flex-col">
      <Typography
        variant="body-1"
        weight="medium"
        className="text-secondary-text"
      >
        {label}
      </Typography>
      {renderValue()}
    </div>
  );
};

export default LabelValueColumn;
